module.exports = __webpack_public_path__ + "img/sclogo.20b4099e.png";